import { getCompaniesAdjustments } from "../utils/WordExportUtils";
import { addTableSpace, generateTable } from "./utils";

export const generateAdjustmentsTable = () => {
  const data = getCompaniesAdjustments();

  const columns = [
    {
      title: "Company Name",
      metric: "company_name",
      color: "blue",
    },
    {
      title: "Currency",
      metric: "currency",
      color: "blue",
    },
    {
      title: "Deduction under s363 CTA 2010",
      metric: "deduction",
      type: "number",
      color: "blue",
    },
    {
      title: "Reduction in deduction under s379 CTA 2010",
      metric: "reduction",
      type: "number",
      color: "blue",
    },
    {
      title:
        "Capital component of rental earnings under non-long funding finance lease",
      metric: "capitalRentalComponent",
      type: "number",
      color: "blue",
    },
  ];

  const table = generateTable(data, columns, [
    "deduction",
    "reduction",
    "capitalRentalComponent",
  ]);

  return [...(table ? [addTableSpace(100), table] : [])];
};
